var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4584_45271)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2168 3.99216C11.2819 3.92709 11.3874 3.92709 11.4525 3.99216L12.5097 5.04937C12.5748 5.11446 12.5748 5.22 12.5097 5.28508L11.3346 6.46011L10.0418 5.16722L11.2168 3.99216ZM9.33465 5.87432L10.6275 7.16722L5.24223 12.5525C5.13546 12.6593 5.00163 12.7351 4.85498 12.7718L3.35516 13.1467L3.73014 11.6468C3.76678 11.5002 3.84257 11.3664 3.94934 11.2596L9.33465 5.87432ZM10.5097 3.28508C10.9653 2.82946 11.704 2.82945 12.1596 3.28507L13.2168 4.34227C13.6724 4.79788 13.6724 5.53657 13.2168 5.99218L5.94933 13.2596C5.71436 13.4946 5.41987 13.6613 5.09762 13.7419L2.78924 14.319C2.61885 14.3616 2.43861 14.3116 2.31442 14.1874C2.19024 14.0632 2.14031 13.883 2.18291 13.7126L2.76001 11.4042C2.8406 11.0819 3.00728 10.7875 3.24224 10.5525L8.98109 4.81366L10.5097 3.28508ZM7.66798 13.3339C7.39184 13.3339 7.16798 13.5577 7.16798 13.8339C7.16798 14.11 7.39184 14.3339 7.66798 14.3339H11.668C11.9441 14.3339 12.168 14.11 12.168 13.8339C12.168 13.5577 11.9441 13.3339 11.668 13.3339H7.66798Z",
    fill: "#76B72A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4584_45271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.e5efe8bc4c6b5cbb6c2c3c35be3f1521.svg";
export { ForwardRef as ReactComponent };